var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRightCallAction = function SvgRightCallAction(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 299 597"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#right-call-action_svg__a)",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    d: "M544.113 298.35c0 135.094-109.772 244.611-245.187 244.611S53.739 433.444 53.739 298.35c0-135.093 109.772-244.611 245.187-244.611S544.113 163.257 544.113 298.35Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#right-call-action_svg__b)",
    strokeOpacity: 0.3,
    strokeWidth: 1.5,
    d: "M.75 298.35C.75 133.992 134.247.75 298.926.75c164.68 0 298.176 133.242 298.176 297.6s-133.497 297.6-298.176 297.6S.75 462.709.75 298.35Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#right-call-action_svg__c)",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    d: "M110.183 298.926c0-104.239 84.503-188.742 188.743-188.742s188.742 84.503 188.742 188.742c0 104.24-84.502 188.743-188.742 188.743s-188.743-84.503-188.743-188.743Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "right-call-action_svg__a",
    x1: 52.989,
    x2: 544.863,
    y1: 543.711,
    y2: 543.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right-call-action_svg__b",
    x1: 597.852,
    x2: 0,
    y1: 0,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right-call-action_svg__c",
    x1: 488.418,
    x2: 109.433,
    y1: 109.434,
    y2: 109.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331",
    stopOpacity: 0.5
  })))));
};
export default SvgRightCallAction;